import React, { useEffect, useState } from "react";
import zh_CN from "antd/es/locale/zh_CN";
import { message, Table, Space, Tag, ConfigProvider, Button } from "antd";
import copy from "copy-to-clipboard";
import "./PressureMeasurement.scss";
import { DownloadOutlined } from "@ant-design/icons";
import SearchHead from "./components/SearchHead"; // 搜索区域
import BoxServe from "../../../ajax/api/index";
import { exportExcel } from "../../../utils/index";

export default function PressureMeasurement(props) {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      width: 200,
      fixed: "left",
    },
    {
      title: "设备号",

      dataIndex: "reqDeviceNo",
      width: 350,
      fixed: "left",
    },
    {
      title: "结果",
      dataIndex: "newResult",
      width: 120,
      render: (_, record) => {
        if (record?.newResult) {
          return <Tag color="#87d068">{record?.newResult}</Tag>;
        }
      },
    },
    {
      title: "备注",
      dataIndex: "remark",
      // width: 120
    },
    {
      title: "操作时间",

      dataIndex: "createTime",
      width: 160,
    },
  ];
  // 提示信息
  const [messageApi, contextHolder] = message.useMessage();
  const [searchParams, setSearchParams] = useState({});
  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 20,
    current: 1,
    defaultPageSize: 20,
  });
  const [loading, setLoading] = useState(false);

  let [list, setList] = useState([]);
  // 总条数
  const [total, setTotal] = useState(0);

  const [pagination, setPagination] = useState({
    page: tableParams.current,
    limit: 20,
  });

  // 搜索
  const handleSearch = (obj) => {
    setSearchParams(obj);
    setTableParams({
      ...tableParams,
      ...obj,
      page: 1,
      current: 1,
    });
    setPagination({
      page: 1,
      limit: 20,
    });
  };

  // 复制
  const handleCopy = (e, contents) => {
    if (copy(contents)) {
      messageApi.open({
        type: "success",
        content: "复制成功！",
      });
    } else {
      messageApi.open({
        type: "error",
        content: "复制失败！",
      });
    }
  };

  // 分页等
  const onChange = (pagination) => {
    const { current, pageSize } = pagination;
    setList([]);
    setPagination({
      page: current,
      limit: pageSize,
    });
    setTableParams({
      page: current,
      current: current,
    });
  };

  useEffect(() => {
    getTasklogList();
  }, [props, searchParams, pagination]);

  // 获取列表数据
  const getTasklogList = async () => {
    try {
      setLoading(true);
      const { code, data, count } = await BoxServe.bandwidthtestList({
        ...tableParams,
        ...searchParams,
        ...pagination,
      }).finally(() => {
        setLoading(false);
      });
      if (String(code) === "0") {
        setTableParams({
          ...tableParams,
          total: count ? Number(count) : 0,
        });
        setTotal(count ? Number(count) : 0);
        const list = data?.map((item) => {
          return {
            ...item,
            key: item.id,
            newResult: item.result ? JSON.parse(item?.result)?.result : "",
          };
        });
        setList(list);
      } else {
        messageApi.open({
          type: "warning",
          content: "出错了~",
        });
      }
    } catch (error) {
      // message.error(error.message || error.msg)
      console.log(error);
    }
  };

  const handleExportExcel = () => {
    const name = `box_压测记录列表_${new Date().getTime()}`;
    const sheetHeader = [];
    const sheetFilter = [];
    const columnWidths = [];

    // const sheetHeader = ["设备号", "状态", "设备所在地", "运行业务"];
    // let sheetFilter = ["deviceNo", "onlineState", "city", "askBusiness"];
    columns?.forEach((item) => {
      let { title, dataIndex, width } = item;
      if (title !== "操作") {
        sheetHeader.push(title);
      }
      sheetFilter.push(dataIndex);
      columnWidths.push(width / 10);
    });
    exportExcel(list, name, sheetHeader, sheetFilter, columnWidths);
  };

  // 重置
  const handleReset = () => {
    setTableParams({
      page: 1,
      limit: 20,
      current: 1,
      defaultPageSize: 20,
    });
    setPagination({
      page: 1,
      // current: 1,
      limit: 20,
    });
  };

  return (
    <>
      {contextHolder}
      <div className="history-wrap">
        <div className="search-wrap">
          <SearchHead handleSearch={handleSearch} handleReset={handleReset} />
        </div>
        <div className="top">
          <div className="top-left"></div>
          <div className="top-right">
            <Space wrap className="operate-btn">
              <Button
                type="dashed"
                danger
                icon={<DownloadOutlined />}
                onClick={handleExportExcel}
              >
                导出Excel
              </Button>
            </Space>
          </div>
        </div>
        <ConfigProvider locale={zh_CN}>
          <Table
            scroll={{ x: "100%" }}
            filterMultiple
            columns={columns}
            dataSource={list}
            loading={loading}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50, 100, 500, 1000, 5000, 10000],
              total,
              ...tableParams,
              showTotal: (total) => {
                return `共 ${total} 条`;
              },
            }}
            onChange={onChange}
          />
        </ConfigProvider>
      </div>
    </>
  );
}
